import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { useOverlayContext } from 'seagull';
import { ArrowSolidRight, Calendar, ChevronRight, Document, Integrations, Message, TwoUsers } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import TutorialVideosModal from '../components/NavigationAndStructure/HelpMenu/TutorialVideosModal/TutorialVideosModal';
import { useIsMobileForHomePage } from './useIsMobileForHomePage';
export var ExternalLink = /*#__PURE__*/ function(ExternalLink) {
    ExternalLink["Link"] = "link";
    ExternalLink["Action"] = "action";
    return ExternalLink;
}({});
export function useHelpMenuExternalLinks() {
    let { hideExploreTutorials = false, hideAskSupport = false, hideVisitHelpCenter = false, hideJoinTheCommunity = false, hideWhatsNew = false, hideBookADemo = false, menuLocation = 'unknown', onOpenTutorialVideosInMobile = ()=>{} } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { intercomClient } = useIoContext();
    const { showModal } = useOverlayContext();
    const isMobileDevice = useIsMobileForHomePage();
    const externalLinks = useMemo(()=>{
        return compact([
            !hideExploreTutorials && {
                label: 'Explore tutorials',
                type: "action",
                suffixIcon: /*#__PURE__*/ _jsx(ChevronRight, {}),
                onClick: ()=>{
                    if (isMobileDevice) {
                        onOpenTutorialVideosInMobile();
                    } else {
                        showModal({
                            closeOnClickOutside: true,
                            closeOnEscapeKey: true,
                            content: (param)=>{
                                let { dismissModal } = param;
                                return /*#__PURE__*/ _jsx(TutorialVideosModal, {
                                    dismissModal: dismissModal
                                });
                            }
                        });
                    }
                },
                icon: ArrowSolidRight
            },
            !hideAskSupport && {
                label: 'Ask support',
                type: "action",
                onClick: ()=>intercomClient.showNewMessage(),
                icon: Message
            },
            !hideVisitHelpCenter && {
                type: "link",
                label: 'Visit help center',
                href: 'https://intercom.help/anchor-billing/en/',
                icon: Document
            },
            !hideJoinTheCommunity && {
                type: "link",
                label: 'Join the community',
                href: 'https://www.facebook.com/groups/sayanchor/',
                icon: TwoUsers
            },
            !hideWhatsNew && {
                type: "link",
                label: "What's new",
                href: 'https://intercom.help/anchor-billing/en/collections/3297243-announcements',
                icon: Integrations
            },
            !hideBookADemo && {
                type: "link",
                label: 'Book a demo',
                href: "https://go.sayanchor.com/website-book-a-demo?utm_channel=product&utm_source=in-app&utm_medium=".concat(menuLocation, "&utm_campaign=book_demo"),
                icon: Calendar
            }
        ]);
    }, [
        hideExploreTutorials,
        hideAskSupport,
        hideVisitHelpCenter,
        hideJoinTheCommunity,
        hideWhatsNew,
        hideBookADemo,
        menuLocation
    ]);
    return {
        externalLinks
    };
}
